export const SendText = 'Send';
export const HowCanIHelpYouTodayText = 'How can I help you today?';
export const SubmitText = 'Submit';
export const CancelText = 'Cancel';
export const HelloText = 'Hello';
export const ChatHistoryText = 'Chat History';
export const EnableWebSearchText = 'Enable Web Search';
export const WebSearchUsedText = 'Web Search Used';
